import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'
import {PrismicRichText} from '@prismicio/react'
import cn from 'classnames'
import type {
  PricingSectionSlice,
  PricingSectionSliceDefaultPrimaryFirstPackageItem,
  PricingSectionSliceReskinPrimaryFirstPackageItem,
} from 'prismicio-types'
import {getModuleCardBackgroundClass} from 'slices/PricingSection/utils/cardStyles'

type PackageCardProps = (
  PricingSectionSliceDefaultPrimaryFirstPackageItem | PricingSectionSliceReskinPrimaryFirstPackageItem
) & {
  variation: PricingSectionSlice['variation']
  iconContainer?: boolean
}

export const PackageCard = (props: PackageCardProps) => {
  const {variation, iconContainer, module_title, description, icon, background_color} = props

  return (
    <div className={cn('flex flex-col gap-4 rounded-lg p-6', getModuleCardBackgroundClass(background_color))}>
      <div className="flex items-start gap-4">
        {isFilled.image(icon) && (
          <div
            className={cn('flex size-8 shrink-0 items-center justify-center', {
              'rounded-[4px] border border-black/[10%] bg-green-neon': iconContainer,
            })}
          >
            <PrismicNextImage field={icon} className="size-4" />
          </div>
        )}
        {isFilled.keyText(module_title) && (
          <h3
            className={cn('font-medium', {
              'text-h5 text-moss-black': variation !== 'reskin',
              'text-tg-body-l text-moss-black': variation === 'reskin',
            })}
          >
            {module_title}
          </h3>
        )}
      </div>

      {isFilled.richText(description) && (
        <PrismicRichText
          field={description}
          components={{
            paragraph: ({children}) => (
              <p
                className={cn({
                  'text-tg-body-l text-grey-550': variation !== 'reskin',
                  'text-tg-body-m text-grey-550': variation === 'reskin',
                })}
              >
                {children}
              </p>
            ),
          }}
        />
      )}
    </div>
  )
}
